import React from "react"

import classNames from "classnames/bind"
import styles from "../styles/Result.module.scss"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"

import api from "../api"
import { calculateResult } from "../util/logic"
import { typeList } from "../constants/type"
import ResultContents from "./ResultContents"
import ResultShareSection from "./ResultShareSection"

class Result extends React.Component {
  state = {
    type: "intj",
  }

  componentDidMount() {
    // 결과 유형 계산
    const { sharedResult, refer, answer, entranceTime, lang, history } = this.props

    // '내 결과 공유하기'로 들어온 경우
    if (sharedResult) {
      const typeName = getTypeNameFromId(sharedResult)

      if (typeName) this.setState({ type: typeName })
      //유효하지 않은 sharedResult 값인 경우 메인으로 강제 이동
      else history.push("/")
    }

    // '내 결과 공유하기'로 들어오지 않고, 일반적인 경로로 접속해 테스트를 수행한 유저의 경우
    else {
      const result = calculateResult(answer)
      this.setState({ type: result })

      // elapsedTime 계산
      const elapsedTime = (new Date() - entranceTime) / 1000
      api.sendTestResult(refer, answer, result, elapsedTime, lang)
    }
  }

  render() {
    const { type } = this.state
    const { sharedResult } = this.props

    return (
      <div className={cn("contents")}>
        <ResultContents type={type} sharedResult={sharedResult} />
        <ResultShareSection type={type} />
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  lang: state.general.lang,
  sharedResult: state.general.sharedResult,
  refer: state.general.refer,
  answer: state.general.answer,
  entranceTime: state.general.entranceTime,
})

const cn = classNames.bind(styles)

const getTypeNameFromId = (id) => {
  for (let index in typeList) {
    if (typeList[index]["id"] === parseInt(id)) {
      return index
    }
  }

  //유효하지 않은 sharedResult 값인 경우
  return false
}

export default withRouter(connect(mapStateToProps)(Result))
